import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { Icon, TIconVariant } from '../../icon'
import { TransactionHistoryItemType } from '@/entities/payments'
import { format, parseISO } from 'date-fns'
import { useMemo, useState } from 'react'
import { TransactionDrawer } from '../../transacitonDrawer'
import { CopyToClipboard } from 'react-copy-to-clipboard'

export const TransactionHistoryItem = (props: TransactionHistoryItemType) => {
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.transactionHistory.paymentsWrapper
  const { classes } = useStyles()
  const { created_at, currency, amount, transaction_id, status } = props
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const imgSrc =
    currency === 'TON' ? 'https://storage.yandexcloud.net/gamed/currencies/TON.webp' : '/assets/webp/icons/tgStar.webp'

  const date = parseISO(created_at)
  const time = format(date, 'HH:mm')
  const expandedTime = format(date, 'dd.MM.yyyy')

  const icon: TIconVariant = useMemo(() => {
    if (status === 'PENDING') {
      return 'transactionProcessing'
    } else if (status === 'PAID') {
      return 'transactionSuccessful'
    } else {
      return 'transactionCanceled'
    }
  }, [status])

  return (
    <>
      <div
        className={classes.root}
        onClick={() => setIsDrawerOpen(true)}
        {...props}
      >
        <div className={classes.idAndAmountWrapper}>
          <div className={classes.idAndAmountWrapper}>
            <Icon view={icon} />
            <div className={classes.paymentTypeAndIdWrapper}>
              <span className={classes.paymentTypeText}>
                {texts.transactionOn} {currency}
              </span>
              <span className={classes.idText}>
                {' '}
                {transaction_id.length > 10
                  ? `${transaction_id.slice(0, 8)}...${transaction_id.slice(-8)}`
                  : transaction_id}
              </span>
            </div>
          </div>
          <div className={classes.amountAndCurrencyWrapper}>
            <span className={classes.amountText}>-{amount}</span>
            <img src={imgSrc} />
          </div>
        </div>
        <div className={classes.statusAndTimeWrapper}>
          <div className={classes.statusWrapper}>
            <span className={classes.statusText}>{texts.status}</span>
            <span
              data-status={status}
              className={classes.statusText}
            >
              {texts[status as keyof typeof texts]}
            </span>
          </div>
          <div>
            <span className={classes.statusText}>{time}</span>
          </div>
        </div>
      </div>
      <TransactionDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onOpen={() => {}}
        header={
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center', paddingTop: '12px' }}>
            <Icon
              view={icon}
              width={48}
            />
            <div className={classes.topContainerStatusWrapper}>
              <span
                data-status={status}
                className={classes.statusText}
                style={{ fontSize: '17px' }}
              >
                {texts[status]}
              </span>
              <div className={classes.amountAndCurrencyWrapper}>
                <span
                  className={classes.amountText}
                  style={{ fontSize: '32px' }}
                >
                  -{amount}
                </span>
                <img
                  src={imgSrc}
                  width={36}
                />
              </div>
            </div>
          </div>
        }
        content={
          <div className={classes.drawerContentWrapper}>
            <div className={classes.drawerContent}>
              <span className={classes.propertyText}>{texts.dateAndTime}</span>
              <span className={classes.valueText}>
                {expandedTime}, {time}
              </span>
            </div>
            <div className={classes.drawerContent}>
              <span className={classes.propertyText}>{texts.transactionId}</span>
              <CopyToClipboard text={transaction_id}>
                <span
                  className={classes.valueText}
                  style={{ cursor: 'pointer' }}
                >
                  {' '}
                  {transaction_id.length > 10
                    ? `${transaction_id.slice(0, 12)}...${transaction_id.slice(-12)}`
                    : transaction_id}
                </span>
              </CopyToClipboard>
            </div>
            <div className={classes.drawerContent}>
              <span className={classes.propertyText}>{texts.status}</span>
              <span className={classes.valueText}>{texts[status]}</span>
            </div>
          </div>
        }
      />
    </>
  )
}
